var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.chatId,
          expression: "!chatId",
        },
      ],
    },
    [
      _c(
        "button",
        {
          staticClass: "ui orange button marunageButton",
          class: _vm.buttonClass,
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.openDialog },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ui modal", attrs: { id: _vm.dialogId } }, [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "scrolling content" },
          [
            _c("detailed-marunage-form", {
              ref: "marunageForm",
              attrs: {
                "action-label": "送信する",
                "form-name-prefix": _vm.formNamePrefix,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }